import store from "@/store";
import { userHasPermissions } from "@/utils/permissions";
import { loginRedirect } from "../utils/authentication";
import MODULE_HOME_ROUTES from "./module-home-routes";

export default function beforeach(router) {
  router.beforeEach((to, from, next) => {
    const tokenLocalStorage = window.sessionStorage.getItem(
      process.env.VUE_APP_TOKEN_KEY
    );

    if (to.path === "/") {
      if (tokenLocalStorage) {
        return next({ path: "/cadastros/buscar-empresas" });
      }
    }

    if (to.matched.some((route) => route.meta.auth == true)) {
      if (!tokenLocalStorage) {
        store.dispatch("ActionSetUsuario");
        return loginRedirect();
      }
    }

    if (!to.meta.auth || !to.meta.permissions.length) {
      return next();
    }

    const userPermissions = store.getters.getPermissoes;
    if (userHasPermissions(userPermissions, to.meta.permissions)) {
      return next();
    } else {
      if (to.path !== "/login/callback" && tokenLocalStorage) {
        // Achado de revisão (BLOQUEANTE): o fallback fixo para
        // /cadastros/buscar-empresas jogava em /access-denied qualquer usuário
        // autenticado que só tivesse permissão de outro módulo (ex.: Acessos).
        // Em vez de um único destino fixo, redireciona para a primeira rota de
        // módulo que o usuário efetivamente tem permissão de acessar.
        const primeiraRotaAcessivel = MODULE_HOME_ROUTES.find((rota) =>
          userHasPermissions(userPermissions, rota.permissions)
        );
        if (primeiraRotaAcessivel) {
          return next({ path: primeiraRotaAcessivel.path });
        }
      }

      // Fail-secure: usuário autenticado sem a permissão exigida pela rota
      // e sem nenhuma permissão de acesso a qualquer módulo. Bloquear por
      // padrão em vez de cair no next() incondicional abaixo (isso deixava
      // passar qualquer rota protegida para quem não tinha nenhuma permissão
      // CENTRAL_CADASTROS_*).
      return next({ path: "/access-denied" });
    }
  });
}
